import React, { memo, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
// import ProductListHotDeals from './ProductListHotDeals';
import BrandSeleList from './BrandSelectionList';


const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});


const BrandSelection = () => {
    const { lang } = useParams();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 575;
    });
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'HotDealsToday', language: "en-US" });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };
    return (
        <section className="hot-deals py-80">
            <div className="container container-md ">
                <div className='brandselection'>
<div className="section-heading">
                    <div
                        className="flex-between flex-wrap gap-8"
                        style={isMobile ? { flexDirection: 'column', alignItems: 'flex-start', width: '100%' } : {}}
                    >
                        <h5 className="mb-0">Shop by Brands</h5>
                        <div
                            className="flex-align mr-point gap-16"
                            style={isMobile ? { width: '100%', justifyContent: 'flex-start', marginTop: '6px' } : {}}
                        >
                            <Link
                                to="/products"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All Deals
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row g-12">
                   
                    <div className="col-12">
                        <div style={isMobile ? { marginTop: '12px' } : {}}>
                        <BrandSeleList />
                        </div>
                       
                    </div>
                </div>
                </div>
                
            </div>
        </section>

    )
}

export default BrandSelection